import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/about-us/loading.jsx");
